import ChartCard from "../../components/ChartCard";
import { FactList, Section } from "../../components/Layout";
import { TagChip } from "../../components/Pills";
import { formatDate, formatNumber } from "../../format";
import { CustomerDetail } from "../../types";

const AccountSection = ({ customer }: { customer: CustomerDetail }) => (
  <Section title="Account">
    <ChartCard
      title="Profile and integrations"
      subtitle="Firestore · users"
      freshness={{ kind: "live" }}
    >
      <FactList
        facts={[
          { label: "Email", value: customer.email || "—" },
          { label: "Account phone", value: customer.phoneNumber || "—" },
          { label: "Followers", value: formatNumber(customer.followerCount) },
          { label: "Profile referrals", value: formatNumber(customer.profileReferralCount) },
          { label: "Events created", value: formatNumber(customer.eventCount) },
          {
            label: "Stripe Connect",
            value: (
              <span style={{ textTransform: "capitalize" }}>
                {customer.stripeAccountStatus || "—"}
              </span>
            ),
          },
          {
            label: "Payouts",
            value: customer.payoutsPaused ? (
              <TagChip label="Paused" tone="critical" />
            ) : (
              <span style={{ textTransform: "capitalize" }}>
                {customer.payoutSchedule || "—"}
              </span>
            ),
          },
          { label: "Twilio number", value: customer.twilio.phone || "—" },
          { label: "Number type", value: customer.twilio.phoneType || "—" },
          {
            label: "Verification",
            value: customer.twilio.verificationStatus || "—",
            title: customer.twilio.verificationUpdatedAt
              ? `Last changed ${formatDate(customer.twilio.verificationUpdatedAt)}`
              : undefined,
          },
          {
            label: "Free-tier messages",
            value: formatNumber(customer.twilio.freeTierMessages),
            title: "Messages sent from the shared Markit number, capped monthly",
          },
        ]}
      />
    </ChartCard>
  </Section>
);

export default AccountSection;
